import React from 'react';

export default function MetadataEditor({seo = {}, onChange}) {
    const update = (field, value) => onChange({...seo, [field]: value});
    return <section className="content-editor-panel" aria-labelledby="metadata-title">
        <h2 id="metadata-title">Search and sharing</h2>
        <label htmlFor="seo-title">Search title</label>
        <input id="seo-title" value={seo.title || ''}
            onChange={event => update('title', event.target.value)} />
        <label htmlFor="seo-description">Search description</label>
        <textarea id="seo-description" rows="3" value={seo.description || ''}
            onChange={event => update('description', event.target.value)} />
        <label htmlFor="social-title">Social sharing title</label>
        <input id="social-title" value={seo.socialTitle || ''}
            onChange={event => update('socialTitle', event.target.value)} />
        <label htmlFor="social-description">Social sharing description</label>
        <textarea id="social-description" rows="3" value={seo.socialDescription || ''}
            onChange={event => update('socialDescription', event.target.value)} />
        <label htmlFor="canonical-url">Canonical URL</label>
        <input id="canonical-url" type="url" value={seo.canonicalUrl || ''}
            placeholder="https://example.com/original"
            onChange={event => update('canonicalUrl', event.target.value)} />
        <label htmlFor="content-byline">Author/byline</label>
        <input id="content-byline" value={seo.byline || ''}
            onChange={event => update('byline', event.target.value)} />
        <label htmlFor="content-tags">Tags</label>
        <input id="content-tags" value={(seo.tags || []).join(', ')}
            onChange={event => update('tags', event.target.value.split(',').map(tag => tag.trim()))} />
        <label className="checkbox" htmlFor="content-no-index">
            <input id="content-no-index" type="checkbox" checked={seo.noIndex === true}
                onChange={event => update('noIndex', event.target.checked)} />
            <span>Hide this content from search engines and the sitemap</span>
        </label>
    </section>;
}
